/**
 * @generated SignedSource<<66916e210ca6f19e9cfa05732a5ca031>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHomeViewsUserPreferencesFragment$data = {
  readonly homePagesDisplayView: PagesDisplayPersistenceOption;
  readonly " $fragmentType": "useHomeViewsUserPreferencesFragment";
};
export type useHomeViewsUserPreferencesFragment$key = {
  readonly " $data"?: useHomeViewsUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHomeViewsUserPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useHomeViewsUserPreferencesFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "homePagesDisplayView"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "3fe421033dfe27b25540bf65e36d452b";

export default node;
